import React from 'react';
import {
	SCREEN,
	ContextualAnalyticsData,
	FireScreenAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import type { SecuritySettingsResponse } from '../services/types';
import { CustomerPermissionsAppUi } from './main';

export type Props = {
	isProjectSimplified: boolean;
	projectKey: ProjectKey;
	source: SecuritySettingsResponse;
	onResourceUpdate?: (newResponse: SecuritySettingsResponse) => void;
};

export const CustomerPermissionsApp = (props: Props) => (
	<ContextualAnalyticsData
		sourceName="customerPermissionsSettings"
		sourceType={SCREEN}
		attributes={{ customerPermissionsVersion: 2 }}
	>
		<CustomerPermissionsAppUi {...props} />
		<FireScreenAnalytics />
		<SpaStatePageReady />
	</ContextualAnalyticsData>
);
